import { withInstall } from '@vuemap/vue-amap-util'
import MarkerCluster from './MarkerCluster.vue'

export const ElAmapMarkerCluster = withInstall(MarkerCluster)
export default ElAmapMarkerCluster
